import { render, staticRenderFns } from "./AdyenEmailForm.vue?vue&type=template&id=522bc2e7"
import script from "./AdyenEmailForm.vue?vue&type=script&lang=js"
export * from "./AdyenEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports